import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {SideMenuLinkConfiguration} from "../../../services/configurations/config-data-sections/side-menu.configuration";
import {observer} from "mobx-react";
import { SideMenuItem } from "../side-menu-link/side-menu-item.component";
import { InternalNavSideMenuLink } from "../../side-menu-rework/side-menu-link/internal-nav-side-menu-link.component";
import { HomeSideMenuIcon } from "../side-menu-link/icons/home-side-menu.icon";
import { SlotsSideMenuIcon } from "../side-menu-link/icons/slots-side-menu-link.icon";
import {NewGamesSideMenuIcon} from "../side-menu-link/icons/new-games-side-menu-link.icon";
import { JackpotsSideMenuIcon } from "../side-menu-link/icons/jackpots-side-menu-link.icon";
import { CasinogamesSideMenuIcon } from "../side-menu-link/icons/casinogames-side-menu-link.icon";
import { Exclusive888SideMenuIcon } from "../side-menu-link/icons/exclusive888-side-menu-link.icon";
import { RouletteSideMenuIcon } from "../side-menu-link/icons/roulette-side-menu-link.icon";
import { BlackjackSideMenuIcon } from "../side-menu-link/icons/blackjack-side-menu-link.icon";
import { LivecasinoSideMenuIcon } from "../side-menu-link/icons/livecasino-side-menu-link.icon";
import { VipSideMenuIcon } from "../side-menu-link/icons/vip-side-menu-link.icon";
import { GettingStartedSideMenuIcon } from "../side-menu-link/icons/gettingstarted-side-menu-link.icon";
import { BankingSideMenuIcon } from "../side-menu-link/icons/banking-side-menu-link.icon";
import { VideoPokerSideMenuIcon } from "../side-menu-link/icons/videopoker-side-menu-link.icon";
import { PromotionsSideMenuIcon } from "../side-menu-link/icons/promotions-side-menu.icon";
import { BlogSideMenuIcon } from "../side-menu-link/icons/blog-side-menu-link.icon";
import { LivechatSideMenuIcon } from "../side-menu-link/icons/livechat-side-menu-link.icon";
import { PokerCircleSideMenuIcon } from "../side-menu-link/icons/poker-circle-side-menu-link.icon";
import { SportCircleSideMenuIcon } from "../side-menu-link/icons/sport-circle-side-menu-link.icon";
import { Club888SideMenuIcon } from "../side-menu-link/icons/club888-side-menu-link.icon";
import { GamingHistorySideMenuIcon } from "../side-menu-link/icons/gaming-history-side-menu-link.icon";
import { CashierHistorySideMenuIcon } from "../side-menu-link/icons/cashier-history-side-menu-link.icon";
import { InstallPwaSideMenuIcon } from "../side-menu-link/icons/installpwa-side-menu-link.icon";
import { LoyaltyBarSideMenuLink } from "../side-menu-link/loyaltybar-side-menu-link.component";
import { SignupSideMenuLink } from "../side-menu-link/signup-side-menu-link.component";
import { DepositSideMenuLink } from "../side-menu-link/deposit-side-menu-link.component";
import { SideMenuListBox } from "../side-menu-link/boxes/side-menu-list.box";
import {CyClass} from '../../../../common/cy-classes';

export interface SideMenuLinksProps {
  menuItemIds: string[];
  className?: string;
}

@observer
export class SideMenuLinksGroup extends OrbitComponent<SideMenuLinksProps> {
    render() {
        const menuItems = this.services.configuration.pickSideMenuItems(this.props.menuItemIds);
        if (!menuItems.some(it => it.config.display)) {
            return null; // none of the elements want to be shown
        }

        return (
            <SideMenuListBox className={this.props.className}>
                <ul className={CyClass('cy-menu-links-group')} style={{margin: "0", listStyleType: "none"}}>
                    { menuItems.map(k =>
                        <SideMenuItem  itemId={k.key} key={k.key} >
                            { this.renderLink(k.key, k.config) }
                        </SideMenuItem>
                    ) }
                </ul>
            </SideMenuListBox>
        )
    }

    private renderLink(key: string, config: SideMenuLinkConfiguration) {
        switch(key) {
            case "home":
                return <InternalNavSideMenuLink config={config} Icon={HomeSideMenuIcon} />;
            case "slots":
                return <InternalNavSideMenuLink config={config} Icon={SlotsSideMenuIcon} />;
            case "newGames":
                return <InternalNavSideMenuLink config={config} Icon={NewGamesSideMenuIcon} />;
            case "jackpots":
                return <InternalNavSideMenuLink config={config} Icon={JackpotsSideMenuIcon} />;
            case "casino":
                return <InternalNavSideMenuLink config={config} Icon={CasinogamesSideMenuIcon} />;
            case "exclusive888arena":
                return <InternalNavSideMenuLink config={config} Icon={Exclusive888SideMenuIcon} />;
            case "roulette":
                return <InternalNavSideMenuLink config={config} Icon={RouletteSideMenuIcon} />;
            case "blackjack":
                return <InternalNavSideMenuLink config={config} Icon={BlackjackSideMenuIcon} />;
            case "liveCasino":
                return <InternalNavSideMenuLink config={config} Icon={LivecasinoSideMenuIcon} />;
            case "vip":
            case "vipClub":
                return <InternalNavSideMenuLink config={config} Icon={VipSideMenuIcon} />;
            case "gettingStarted":
                return <InternalNavSideMenuLink config={config} Icon={GettingStartedSideMenuIcon} />;
            case "banking":
                return <InternalNavSideMenuLink config={config} Icon={BankingSideMenuIcon} />;
            case "videoPoker":
                return <InternalNavSideMenuLink config={config} Icon={VideoPokerSideMenuIcon} />;

            case "promotions":
            case "promotionsCIP":
            case "promotionsCIS":
                return <InternalNavSideMenuLink config={config} Icon={PromotionsSideMenuIcon} onClick={this.services.menuFlow.promptPushNotificationPermissionRequest} />;
            case "blog":
                return <InternalNavSideMenuLink config={config} Icon={BlogSideMenuIcon} />;
            case "liveChat":
                return <InternalNavSideMenuLink config={config} Icon={LivechatSideMenuIcon} />;
            case "888poker":
            case "pokerAppStore":
            case "backTo888Poker":
                return <InternalNavSideMenuLink config={config} Icon={PokerCircleSideMenuIcon} />;
            case "888sport":
            case "sportAppStore":
            case "backTo888Sport":
                return <InternalNavSideMenuLink config={config} Icon={SportCircleSideMenuIcon} />;
            case "myClub":
            case "888club":
                return <InternalNavSideMenuLink config={config} Icon={Club888SideMenuIcon} />;
            case "downloadApp":
            case "installPWA":
                return <InternalNavSideMenuLink config={config} Icon={InstallPwaSideMenuIcon} />;

            case "loyaltyBar":
                return <LoyaltyBarSideMenuLink />;

            case "signUp":
                return <SignupSideMenuLink config={config} />;
            case "deposit":
                return <DepositSideMenuLink config={config} />;

            case "gamingHistory":
                return <InternalNavSideMenuLink config={config} Icon={GamingHistorySideMenuIcon} withArrow={true} />;
            case "cashierHistory":
                return <InternalNavSideMenuLink config={config} Icon={CashierHistorySideMenuIcon} withArrow />;
            default:
                this.services.logger.error(`There is no SideMenuLink implementation for key: ${key}`);
                return null;
        }
    }

}
